module.exports = __webpack_public_path__ + "img/test.f0d3439d.svg";